<div class="container gamesViewIframe" *ngIf="show" (click)="muteall()">
    <iframe scrolling="yes" id="myVideo" [src]="controllerSrc" title="Iframe Example"></iframe>
</div>